import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IAppBreadcrumbs } from '@app/layout/breadcrumbs/interfaces/app-breadcrumbs.interface';
/**
 * Сервис для управления хлебными крошками в приложении
 *
 * @package APP
 * @version 1.0
 * @author Bolotov I. P.
 * @since 30.03.2023
 * @copyright (c) Internet-Frigate {@link http://www.ifrigate.ru}
 */
@Injectable({
    providedIn: 'root',
})
export class AppBreadcrumbsService {
    /** Массив хлебных крошек */
    private _breadcrumbsList$: BehaviorSubject<IAppBreadcrumbs[]> = new BehaviorSubject<IAppBreadcrumbs[]>([]);

    /** Получить Массив хлебных крошек */
    public get breadcrumbsList$(): Observable<IAppBreadcrumbs[]> {
        return this._breadcrumbsList$.asObservable();
    }

    /**
     * Установка хлебных крошек
     * @param items - массив хлебных крошек
     */
    public setBreadcrumbs(items: IAppBreadcrumbs[]): void {
        this._breadcrumbsList$.next(items);
    }

    /**
     * Добавление хлебных крошек к существующим
     * @param item - элемент хлебных крошек
     */
    public addBreadcrumbs(item: IAppBreadcrumbs): void {
        const arr = this._breadcrumbsList$.value;
        arr.push(item);
        this._breadcrumbsList$.next(arr);
    }

    /**
     * Получить элемент хлебных крошек по индексу
     * @param index - индекс
     * Если индекс будет отрицательным, отчет элементов будет с конца элемент хлебных крошек
     */
    public getItemByIndex(index: number = 0): IAppBreadcrumbs | null {
        const arr = this._breadcrumbsList$.value;
        const safeIndex = index < 0 ? arr.length + index : index;

        if (safeIndex >= 0 && safeIndex < arr.length && arr[safeIndex]) {
            return arr[safeIndex];
        }

        return null;
    }

    /** Получения массива хлебных крошек */
    public getBreadcrumbs(): IAppBreadcrumbs[] {
        return this._breadcrumbsList$.value;
    }
}
